import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import { Chain } from '../api/types';
import config from '../config';

async function getChain(axios: AxiosInstance, id: number): Promise<Chain> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/chain/` + id);
  return data;
}

export default function useChainQuery(id: number) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(id),
    queryFn: () => getChain(axios, id),
    enabled: !!id,
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey(id: number) {
  return ['Chain', id] as const satisfies QueryKey;
}

useChainQuery.getKey = getKey;
